/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Abdou Sall",
  title: "Salut, c'est Abdou",
  subTitle: emoji(
"Un développeur Front End qui crée des applications web en utilisant Javascript/React/Nodejs. À la recherche d'une alternance."  ),
  resumeLink:
    "https://drive.google.com/file/d/1AOCigVOrRGmLo0hvucy-sXiaOzpGOQ8w/view?usp=sharing", //A CORRIGER
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/SallAbdou",
  linkedin: "https://www.linkedin.com/in/pape-sall-06784b181/",
  gmail: "sall.abdou34@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Mes Compétences",
  skills: [
    emoji(
      "⚡ Développement d'interfaces utilisateur interactives pour vos applications web et mobiles"
    ),
    emoji(
      "⚡ Intégration de services tiers"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Openclassrooms",
      logo: require("./assets/mes-images/openclassrooms-logo.png"),
      duration: "Septembre 2023 - Avril 2025",
      subHeader: "Développeur d'application Javascript/React",
      desc: "Apprentissage du développement en HTML/CSS, et développement de premiers projets",
      
    },
    {
      schoolName: "Esicad Montpellier",
      logo: require("./assets/mes-images/esicad.jpg"),
      duration: "Septembre 2017 - Juin 2019",
      subHeader: "Bts Services informatiques aux organisations: option SISR",
      desc: "",
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "HTML", 
      progressPercentage: "90%" 
    },
    {
      Stack: "CSS", 
      progressPercentage: "90%" 
    },
    {
      Stack: "Javascript/React",
      progressPercentage: "70%"
    },
    {
      Stack: "Conception de maquette",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Responsable du Parc Informatique",
      company: "Collège Simone Veil",
      companylogo: require("./assets/mes-images/logo/herault-logo.webp"),
      date: "Septembre 2019 – Août 2022",
      desc: "",
      descBullets: [
        "Installer, configurer et maintenir les équipements informatiques et les périphériques.",
        "Gérer les connexions réseau",
        "Installer, mettre à jour et gérer les logiciels pédagogiques, bureautiques ou de gestion.",
        "Configuration avancée (routage, VLAN, sécurité…)"
      ]
    },
    {
      role: "Stage de technicien réseau - itinérant",
      company: "Bouygues Télécom",
      companylogo: require("./assets/mes-images/logo/bouygues-logo.webp"),
      date: "Janvier 2019 – Mai 2019",
      desc: "",
      descBullets:[
        "Installation et configuration d’équipements réseau (routeurs, switchs, bornes Wi-Fi…).",
        "Câblage et tests de connectivité.",
        "Diagnostic et dépannage des réseaux chez différents clients.",
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Mes Projets",
  subtitle: "Des projets que j'ai réalisé, pour mon diplôme d'Openclassrooms",
  projects: [
    {
      image: require(".//assets/mes-images/logo/petitsplats-logo.webp"),
      projectName: "Les Petits Plats",
      projectDesc: "Reproduire une maquette, créer un algorithme de recherche à partir de données au format JSON, produire une documentation complète, pour l’équipe responsable du backend",
      footerLink: [
        {
          name: "Visiter le Site",
          url: "https://p7-delta.vercel.app/"
        }
      ]
    },
    {
      image: require(".//assets/mes-images/logo/ohmyfood-logo.webp"),
      projectName: "OhMyFood",
      projectDesc:"Reproduire une maquette sur la base du mobile first, réaliser les animations, intégrations des différentes pages du restaurant",
      footerLink: [
        {
          name: "Visiter le Site",
          url: "https://p3-beta.vercel.app/"
        }
      ]
    },
    {
      image: require("./assets/mes-images/logo/fisheye-logo.webp"),
      projectName: "FishEye ",
      projectDesc: "Créer une page d’accueil regroupant chaque photographes, et générer de manière dynamique leurs pages personnelles à base d’un fichier JSON",
      footerLink: [
        {
          name: "Visiter le Site",
          url: "https://p6-eight.vercel.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require(".//assets/mes-images/logo/kasa-logo.webp"),
      projectName: "Kasa",
      projectDesc: "Développement de l'ensemble de l'application, à partir d'une maquette. Génération des pages à partir du fichier JSON.",
      footerLink: [
        {
          name: "Visiter le Site",
          url: "https://p11-taupe.vercel.app/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};





// Podcast Section


// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contactez moi ☎️"),
  subtitle:
    "Si vous voulez prendre contact avec moi, vous pouvez m'écrire par mail ou sur mes réseaux.",
  email_address: "sall.abdou34@gmail.com"
};


const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  contactInfo,
  isHireable,
  resumeSection
};
